exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "textarea {\n  resize: none; }\n\n.mat-input-container {\n  margin-right: 145px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/users/components/user-add/user.component.scss
// module id = 511
// module chunks = 5